export default __webpack_public_path__ + "static/media/08exigo.2073f183.jpg";